import { Router } from '@reach/router';

import ViewScan from './views/ViewScan';
import LoadCard from './views/LoadCard';
import LoadCardPay from './views/LoadCardPay';
import LoadCardConfirmation from './views/LoadCardConfirmation';
import AddMessage from './views/AddMessage';
import AddFunds from './views/AddFunds';
import VideoPreview from './views/VideoPreview';
import GiftConfirmation from './views/GiftConfirmation';
import Landing from './views/Landing';
import TrendingTopics from './views/TrendingTopics';
import Checkout from './views/Checkout';
import CreateAccount from './views/CreateAccount';
import ScanCard from './views/ScanCard';

const GiftRedemptionRouter = () => (
  <Router primary={false} id="gift-redeem" path="/">
    <LoadCard path="load" />
    <LoadCardPay path="load/pay" />
    <LoadCardConfirmation path="load/confirmation" />
    <AddMessage path="message" />
    <AddFunds path="funds" />
    <VideoPreview path="video" />
    <GiftConfirmation path="confirmation" />
    <Landing path="landing" />
    <TrendingTopics path="trending-topics" />
    <Checkout path="checkout" />
    <CreateAccount path="create-account" />
    <ScanCard path="scan" />
    {/* Default route */}
    <ViewScan path="/" />
  </Router>
);

export default GiftRedemptionRouter;
